import { render, staticRenderFns } from "./XInputGroups.vue?vue&type=template&id=8b682c38"
import script from "./XInputGroups.vue?vue&type=script&lang=js"
export * from "./XInputGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports